module.exports = __webpack_public_path__ + "img/ZGYH.04cb172b.png";